import { userStorage } from '@/configs/storages';
import { register } from '../oauth';
import { clearAll, clearDB, clearOPFS } from './clearData';
import { debugLevel } from './config';
import { addDebugApis } from './apis';
import { importDirectoryToOpfs } from './backup';

if (debugLevel) {
  window.addEventListener('keydown', async (e) => {
    if (e.key === 'Delete') {
      try {
        if (e.ctrlKey) {
          const { deleteFCMToken } = await import('@/configs/firebase/config');
          await deleteFCMToken();
          await clearAll();
        } else if (e.shiftKey) {
          await clearDB();
        }
      } catch (err) {
        alert('ClearData error');
        throw err;
      }
    }
  });
}

let iframe: any = null;

addDebugApis({
  oauth: {
    register(src: string) {
      if (iframe) {
        iframe.unregister();
        document.body.removeChild(iframe);
      }

      iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.style.cssText = `
      position: fixed;
      top: 0;
      right: 0;
      width: 50vw;
      height: 50vh;
      border: none;
      z-index: 1000;
      background-color: red;
    `;
      document.body.appendChild(iframe);
      iframe.unregister = register(iframe);
    },
  },
});

export const debugInitPromise = (async () => {
  const flag = userStorage.getItem('clear_DB_flag');
  if (flag) {
    await clearOPFS();
    userStorage.removeItem('clear_DB_flag');
  } else {
    const importFlag = userStorage.getItem('import_OPFS_flag');
    if (importFlag) {
      const button = document.createElement('button');
      button.textContent = 'Import OPFS';
      document.body.appendChild(button);
      await new Promise<void>((resolve) => {
        button.onclick = async () => {
          await importDirectoryToOpfs();
          button.remove();
          userStorage.removeItem('import_OPFS_flag');
          resolve();
          location.reload();
        };
      });
    }
  }
})();

await debugInitPromise;
